export const focusInput = input => {
  const elemento = document.getElementById(input);
  if (elemento) {
    setTimeout(() => {
      elemento.focus();
    }, 150);
  }
};

export const focusInputRef = inputRef => {
  setTimeout(() => {
    inputRef.current.focus();
  }, 100);
};

export const encodeBase64UrlSafe = str =>
  btoa(encodeURIComponent(str))
    .replace(/\+/g, '-') // substitui '+' por '-'
    .replace(/\//g, '_') // substitui '/' por '_'
    .replace(/=+$/, ''); // remove '=' do final

export const decodeBase64UrlSafe = str => {
  // Recoloca os caracteres e completa os '=' se necessário
  str = str.replace(/-/g, '+').replace(/_/g, '/');

  // Adiciona padding '=' se necessário
  const padding = str.length % 4;
  if (padding) str += '='.repeat(4 - padding);

  return decodeURIComponent(atob(str));
};

export const baixarArquivoBlob = (nomeArquivo, conteudoArquivo, tipoArquivo) => {
  const blob = new Blob([conteudoArquivo], { type: tipoArquivo });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', nomeArquivo);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
